// Airwallex refund state of a row, from the airwallex_* fields the BE sets
// (RefundSummary): the screens never work the refundable amount out themselves.

const money = (value) => "$" + Number(value || 0).toFixed(2);

// Refund button: something still refundable on Airwallex.
export function canRefundAirwallex(row) {
  return !!row && !!row.airwallex_order_id && Number(row.airwallex_refundable || 0) > 0;
}

// One line under the row: a refund not final yet, or why the latest failed.
export function airwallexRefundNote(row) {
  if (!row || !row.airwallex_order_id) return null;
  if (Number(row.airwallex_refund_processing || 0) > 0) {
    return { error: false, text: `Refund processing ${money(row.airwallex_refund_processing)}` };
  }
  // Charge not confirmed by Airwallex yet: no refund sent, settled automatically.
  if (Number(row.airwallex_refund_checking || 0) > 0) {
    return { error: false, text: `Checking refund ${money(row.airwallex_refund_checking)} with Airwallex - not sent yet` };
  }
  if (row.airwallex_refund_error) {
    return { error: true, text: `Refund failed: ${row.airwallex_refund_error}` };
  }
  return null;
}
